import { NotificationType } from '../enums/NotificationId';
import { NotificationLevel } from '../enums/NotificationLevel';

/** Level of the notifications the web UI calculates; server notifications carry their severity. */
export const notificationLevelMap = {
  [NotificationType.NO_VOLUME_PROVIDED]: NotificationLevel.WARNING,
  [NotificationType.THERAPY_JOB_UPDATED]: NotificationLevel.INFO
};

export const notificationActionMap = {
  [NotificationType.NO_VOLUME_PROVIDED]: 'NotificationNoVolumeProvidedActionButton',
  [NotificationType.THERAPY_JOB_UPDATED]: 'AcknowledgeChangesPanelActionButtonUpdated',
  // Abort button
  [NotificationType.THERAPY_JOB_CANCELLED]: 'AcknowledgeChangesPanelActionButtonDeleted',
  [NotificationType.THERAPY_JOB_STOPPED]: 'AcknowledgeChangesPanelActionButtonDeleted',
  [NotificationType.THERAPY_JOB_MARK_FOR_DELETION]: 'AcknowledgeChangesPanelActionButtonDeleted'
};
